var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 15H2.5C1.25583 15 0 14.055 0 11.945V7.74503C0.0175226 5.83017 0.734522 3.98779 2.01598 2.56482C3.29744 1.14184 5.05493 0.236473 6.9575 0.0191962C8.03113 -0.0587419 9.10896 0.0953475 10.1178 0.470994C11.1265 0.84664 12.0426 1.43504 12.8038 2.19621C13.565 2.95738 14.1534 3.87349 14.529 4.88228C14.9047 5.89107 15.0588 6.9689 14.9808 8.04253C14.7633 9.94588 13.8571 11.7039 12.4332 12.9855C11.0092 14.267 9.16567 14.9835 7.25 15ZM16.6667 7.5667H16.6567C16.6567 7.7642 16.6567 7.9617 16.6467 8.16003C16.325 12.6667 12.2058 16.4817 7.57 16.6509V16.6634C8.15384 17.676 8.99364 18.5172 10.0052 19.1029C11.0167 19.6885 12.1645 19.9979 13.3333 20H17.5C18.163 20 18.7989 19.7366 19.2678 19.2678C19.7366 18.799 20 18.1631 20 17.5V13.3334C19.9988 12.1643 19.6902 11.0161 19.1051 10.0039C18.5201 8.99175 17.6791 8.15124 16.6667 7.5667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChats);
export default __webpack_public_path__ + "static/media/chats.169ac74280008c444d1e3fea6cc6eea1.svg";
export { ForwardRef as ReactComponent };